<template>
    <div>
        <vs-dialog v-model="active" auto-width prevent-close>
            <template #header>
            <h4 class="not-margin">
                Subir fotos de forma masiva
            </h4>
            </template>
            <div class="con-form">
                <div class="flex w-full h-screen items-center justify-center text-center" id="app">
                    <div class="p-12 bg-gray-100 border border-gray-300" @dragover="dragover" @dragleave="dragleave" @drop="drop">
                        <input type="file" multiple name="fields[assetsFieldHandle][]" id="assetsFieldHandle" 
                        class="w-px h-px opacity-0 overflow-hidden absolute" @change="onChange" ref="file" accept=".jpg,.jpeg,.png" />
                    
                        <label for="assetsFieldHandle" class="block cursor-pointer">
                        <div class="p-3">
                            <p><strong>Arrastre o de click para subir imagenes de alumnos</strong></p>
                            <p class="mb-0">(Es necesario la imagen tenga por nombre la matricula y extensión .jpg)
                            Las imagenes deben ser de 127px * 158px </p>
                        </div>
                        </label>
                        <vs-row v-if="filelist.length" v-cloak class="p-3">
                            <vs-col v-for="(file, i) in filelist" :key="i" sm="6" lg="3" style="display: flex; align-items: center;">
                                <p class="mb-0">{{ file.name }}</p>
                                <vs-button
                                    shadow
                                    size="small"
                                    @click="remove(filelist.indexOf(file))"
                                >
                                    <i class="fas fa-times"></i>
                                </vs-button>
                            </vs-col>
                        </vs-row>
                    </div>
                </div>
            </div>
            <template #footer>
                <vs-button
                    class="ml-auto"
                    @click="postGuardarImagenes()"
                >
                    Guardar
                </vs-button>
            </template>
        </vs-dialog>
    </div>
</template>

<script>
export default {
    props:[
        'value',
    ],
    data: () => ({ 
        filelist: [],
        active: false 
    }),
    methods:{
        onChange() {
        this.filelist = [...this.$refs.file.files];
        },
        remove(i) {
        this.filelist.splice(i, 1);
        },
        dragover(event) {
        event.preventDefault();
        // Add some visual fluff to show the user can drop its files
        if (!event.currentTarget.classList.contains('bg-green-300')) {
            event.currentTarget.classList.remove('bg-gray-100');
            event.currentTarget.classList.add('bg-green-300');
        }
        },
        dragleave(event) {
        // Clean up
        event.currentTarget.classList.add('bg-gray-100');
        event.currentTarget.classList.remove('bg-green-300');
        },
        drop(event) {
        event.preventDefault();
        this.$refs.file.files = event.dataTransfer.files;
        this.onChange(); // Trigger the onChange event manually
        // Clean up
        event.currentTarget.classList.add('bg-gray-100');
        event.currentTarget.classList.remove('bg-green-300');
        },
        postGuardarImagenes(){
            const loading = this.$vs.loading()
            const vue = this
            let formData = new FormData();
            this.filelist.forEach((element, index) => {
                formData.append('files[' + index + ']', element);
            })
            axios.post( '/api/personas/bulkLoad',
                formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
            ).then(function(){
                vue.$vs.notification({
                    progress: 'auto',
                    color: 'success',
                    position: null,
                    title: 'Operación éxitosa.',
                    text: 'Imagenes cargadas con éxito.'
                })
                loading.close()
                 vue.active = false
                vue.$emit('refreshTable')
                console.log('Entro');
            })
            .catch(function(error){
                vue.$vs.notification({
                    progress: 'auto',
                    color: 'danger',
                    position: null,
                    title: 'Error.',
                    text: 'Error al carga.'
                })
                loading.close()
                 vue.active = false
                console.log('FAILURE!!', error);
            });
        }
    },
    watch:{
        value (val) {
            this.active = val
        },       
        async active (val) {
            if (!val){
                this.$emit('input', val);
            }
        }
    }
}
</script>

<style>
[v-cloak] {
  display: none;
}
</style>